export const CHANNEL_SET_DATA_ACTION="CHANNEL_SET_DATA_ACTION"
export const CHANNEL_GET_DATA_ACTION="CHANNEL_GET_DATA_ACTION"
